module.exports = __webpack_public_path__ + "static/media/startKyc1.4a51ba17.png";